// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"541":"da458701","627":"425a1fef"}[chunkId] || chunkId) + "." + {"541":"cb543161b57d87df","627":"074d09a74def6d78","7836":"33e31cf917491f0a","9660":"fa5f1a9f44b88e1b"}[chunkId] + ".js";
};